export class MenuLink {
  text: string;
  link: string;
  children: MenuLink[] = [];
  queryParams: {};

  constructor(
    link: string,
    text: string,
    children: MenuLink[] = [],
    queryParams: {} = null
  ) {
    this.text = text;
    this.link = link;
    this.children = children;
    this.queryParams = queryParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/menu/menu-link.model.ts